<template>
	<b-modal
		hide-footer
		:no-close-on-backdrop="true"
		ref="modal-view"
		size="lg"
		:title="this.$t('global.selectSystem')"
	>
		<form @submit="onSubmit">
			<b-row>
				<b-col sm="12">
					<b-form-group :label="this.$t('global.pointOfSale')">
						<b-form-select v-model="selected" :options="options" class="mt-2" required/>
					</b-form-group>
				</b-col>
				<b-col class="mt-3">
					<b-button block variant="info" type="submit">{{ this.$t('login.access') }}</b-button>
				</b-col>
			</b-row>
		</form>
	</b-modal>
</template>

<script>
import Resize from "../../helpers/Resize.js";

export default {
	mixins: [Resize],
	props: {
		successCallback: {
			type: Function,
			required: false,
			default: () => {
			}
		}
	},
	components: {},
	data() {
		let opts = {}
		return {
			selected: null,
			Opts: {...opts},
			loading: true,
		};
	},
	computed: {
		options() {
			if (Array.isArray(this.Opts.pos)) {
				return this.Opts.pos.map(item => ({
					value: item.id,
					text: item.codename
				}))
			} else {
				return []
			}
		},
	},
	methods: {
		loadModel(options) {
			this.$refs["modal-view"].show();
			this.Opts = options
		},

		onSubmit(event) {
			event.preventDefault()
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true

			this.$root.api.post('/auth/system', null, {
				headers: {
					"X-SC-TYPE": 'pos',
					"X-SC-SYSTEM": this.selected,
				}
			}).then((response) => {
				this.$root.store.setSystemData(response.data)

				this.$root.api.post('/auth/me').then((response2) => {
					this.$root.store.setUserData(response2.data)
					this.$router.push('/')
				})
			}).catch(() => {
				this.loading = false;
				this.error = true;
			})
		},
	},
	mounted() {
		console.log("mounted single (?");
	}
};
</script>

<style></style>
